<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content">
            <v-card-title>
                Nouveau Dossier 
              <!--<v-radio-group v-model="row" row>
                <v-radio label="Import" value="import"></v-radio>
                <v-radio label="Export" value="export"></v-radio>
              </v-radio-group> -->
                <v-spacer></v-spacer>

            </v-card-title>
            <v-row>
                <v-col cols="12" sm="2">
                    <v-select
                    v-model="selectedFilter"
                    :items="filterSelectbox"
                    label="Type"
                    outlined
                    @change="printValue"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-select
                    v-model="classe"
                    :items="['Complet', 'Groupage', 'Aérien']"
                    label="Classe"
                    outlined
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="8">
                <v-text-field
                    label="N°Dossier"
                    outlined
                    :value="dossiernum"
                    disabled
                ></v-text-field>
                </v-col>
                <template v-if="classe == 'Complet' || classe == 'Groupage'">
                  <v-col cols="12" sm="6" style="position:relative;">
                    <v-autocomplete
                        v-model="navire"
                        :items="navireList"
                        item-text="titre"
                        item-value="id"
                        outlined
                        label="Navire"
                    ></v-autocomplete>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="position: absolute;right: 65px;top: 13px;" color="primary" v-bind="attrs" v-on="on" @click="openAddingTab('navire')" icon fab><v-icon>mdi-plus</v-icon></v-btn>
                      </template>
                      <span>Ajouter Navire</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="12" sm="6" style="position:relative;">
                    <v-autocomplete
                        v-model="armateur"
                        :items="armateurList"
                        item-text="titre"
                        item-value="id"
                        outlined
                        label="Armateur"
                    ></v-autocomplete>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="position: absolute;right: 65px;top: 13px;" color="primary" v-bind="attrs" v-on="on" @click="openAddingTab('armateur')" icon fab><v-icon>mdi-plus</v-icon></v-btn>
                      </template>
                      <span>Ajouter Armateur</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" style="position:relative;">
                    <v-autocomplete
                        v-model="portFrom"
                        :items="portList"
                        item-text="titre"
                        item-value="id"
                        outlined
                        label="Embarquement de"
                    ></v-autocomplete>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn style="position: absolute;right: 65px;top: 13px;" color="primary" v-bind="attrs" v-on="on" @click="openAddingTab('port')" icon fab><v-icon>mdi-plus</v-icon></v-btn>
                        </template>
                        <span>Ajouter Port</span>
                      </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6">
                  <v-menu
                    ref="menu_from"
                    v-model="menu_from"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_from"
                        label="Le"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        :value="date_from | formatDate"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date_from" @input="menu_from = false" no-title scrollable>
                      <!--<v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_from = false">Annuler</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_from.save(date_from)">OK</v-btn>-->
                    </v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" style="position:relative;">
                    <v-autocomplete
                        v-model="portTo"
                        :items="portList"
                        item-text="titre"
                        outlined
                        label="Débarquement à "
                        item-value="id"
                    ></v-autocomplete>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn style="position: absolute;right: 65px;top: 13px;" color="primary" v-bind="attrs" v-on="on" @click="openAddingTab('port')" icon fab><v-icon>mdi-plus</v-icon></v-btn>
                        </template>
                        <span>Ajouter Port</span>
                      </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6">
                  <v-menu
                    ref="menu_to"
                    v-model="menu_to"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_to"
                        label="Le"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min="date_from+1" v-model="date_to" @input="menu_to = false" no-title scrollable>
                      <!--<v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_to = false">Annuler</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_to.save(date_to)">OK</v-btn>-->
                    </v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                  <v-text-field
                      label="Numéro Escale"
                      outlined
                      v-model="numEscale"
                  ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                  <v-menu
                    ref="menu_escale"
                    v-model="menu_escale"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_escale"
                        label="Date Escale"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min="date_from" v-model="date_escale" @input="menu_escale = false" no-title scrollable>
                      <!--
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_escale = false">Annuler</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_escale.save(date_escale)">OK</v-btn>
                      -->
                    </v-date-picker>
                  </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                  <v-text-field

                      label="Numero voyage"
                      outlined
                      v-model="numVoyage"
                  ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" style="position:relative;">
                    <v-autocomplete
                        v-model="consig"
                        :items="consigList"
                        item-text="nom"
                        item-value="id"
                        outlined
                        label="Consignataire"
                    ></v-autocomplete>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="position: absolute;right: 65px;top: 13px;" color="primary" v-bind="attrs" @click="openAddingTab('consig')" v-on="on" icon fab><v-icon>mdi-plus</v-icon></v-btn>
                      </template>
                      <span>Ajouter Consignataire</span>
                    </v-tooltip>
                  </v-col>
                </template>
                <template v-if="classe == 'Groupage'">
                <v-col cols="12" sm="6" style="position:relative;">
                  <v-autocomplete
                      v-model="type_conteneur"
                      :items="conteneurList"
                      item-text="titre"
                      item-value="id"
                      outlined
                      label="Type Conteneur"
                  ></v-autocomplete>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn style="position: absolute;right: 65px;top: 13px;" color="primary" v-bind="attrs" @click="openAddingTab('conteneur')" v-on="on" icon fab><v-icon>mdi-plus</v-icon></v-btn>
                    </template>
                    <span>Ajouter Type Conteneur</span>
                  </v-tooltip>
                </v-col>

                <v-col cols="12" sm="6">
                <v-text-field
                    v-model="conteneur_num"
                    outlined
                    label="N°Conteneur"
                ></v-text-field>
                </v-col>


                <v-col cols="12" sm="6">
                <v-text-field
                    v-model="num_escale_magasin"
                    outlined
                    label="N°Escale Magasin"
                ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-menu
                    ref="menu_depotage"
                    v-model="menu_depotage"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_depotage"
                        label="Date Dépotage"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min="date_to" v-model="date_depotage" @input="menu_depotage = false" no-title scrollable>
                      <!--
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_depotage = false">Annuler</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_depotage.save(date_depotage)">OK</v-btn>-->
                    </v-date-picker>
                  </v-menu>
                  </v-col>
                </template>


                <template v-if="classe == 'Aérien'">
                  <v-col cols="12" sm="4">
                  <v-text-field
                      v-model="compagnie_aerienne"
                      outlined
                      label="Compagnie Aérienne"
                  ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                  <v-text-field
                      v-model="num_lta"
                      outlined
                      label="N°LTA"
                  ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                  <v-text-field
                      v-model="num_vol"
                      outlined
                      label="N° Vol"
                  ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                  <v-text-field
                      v-model="aeroport_depart"
                      outlined
                      label="Aéroport Départ"
                  ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                  <v-text-field
                      v-model="aeroport_arrivee"
                      outlined
                      label="Aéroport D'arrivée"
                  ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                  <v-menu
                    ref="menu_from"
                    v-model="menu_from"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_from"
                        label="Date Départ"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date_from" @input="menu_from = false" no-title scrollable><!--
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_from = false">Annuler</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_from.save(date_from)">OK</v-btn>-->
                    </v-date-picker>
                  </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                  <v-menu
                    ref="menu_to"
                    v-model="menu_to"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_to"
                        label="Date Arrivée"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date_to" :min="date_from" @input="menu_to = false" no-title scrollable><!--
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_to = false">Annuler</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_to.save(date_to)">OK</v-btn>-->
                    </v-date-picker>
                  </v-menu>
                  </v-col>
                </template>
                <v-col cols="12" sm="12" class="text-right">
                  <div class="my-2">
                    <v-btn text>Rétablir</v-btn>
                    <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addFolder">Ajouter</v-btn>
                  </div>
                </v-col>

            </v-row>
          </v-card>
          <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            multi-line
            app
          >
            {{snackbarText}}
            <v-btn
              text
              dark
              @click="snackbar = false"
            >
              Fermer
            </v-btn>
          </v-snackbar>
        </v-col>
      </v-row>
      <v-dialog v-model="addNavireDialog" v-if="addNavireDialog" max-width="600px">
        <add-navire v-on:close="addNavireDialog = false" v-on:reloadData="reloadData"  @hide="addNavireDialog = false"></add-navire>
      </v-dialog>
      <v-dialog v-model="addArmateurDialog" v-if="addArmateurDialog" max-width="600px">
        <add-armateur v-on:close="addArmateurDialog = false" v-on:reloadData="reloadData"  @hide="addArmateurDialog = false"></add-armateur>
      </v-dialog>
      <v-dialog v-model="addConsigDialog" v-if="addConsigDialog" max-width="600px">
        <add-consig v-on:close="addConsigDialog = false" v-on:reloadData="reloadData"  @hide="addConsigDialog = false"></add-consig>
      </v-dialog>
      <v-dialog v-model="addConteneurDialog" v-if="addConteneurDialog" max-width="600px">
        <add-conteneur v-on:close="addConteneurDialog = false" v-on:reloadData="reloadData"  @hide="addConteneurDialog = false"></add-conteneur>
      </v-dialog>
      <v-dialog v-model="addPortDialog" v-if="addPortDialog" max-width="600px">
        <add-port v-on:close="addPortDialog = false" v-on:reloadData="reloadData"  @hide="addPortDialog = false"></add-port>
      </v-dialog>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from '../commons/header_sidebar.component'
import addNavire from '../database/navire/add.component'
import addConsig from '../database/consig/add.component'
import addArmateur from '../database/armateur/add.component'
import addConteneur from '../database/conteneur/add.component'
import addPort from '../database/port/add.component'
export default {
  name: 'newFolder',
  components: {headerSidebar, addNavire, addConsig, addArmateur, addConteneur, addPort},
  data: () => ({
    drawer: true,
    addingTab : false,
    business: 5,
    snackbar: false,
    snackbarText: '',
    color: "success",
    selectedFilter: "Import",
    filterSelectbox: [
        {text : 'Import', value : 'Import'},
        {text : 'Export', value : 'Export'},
    ],
    mini: false,
    search: '',
    classe: 'Complet',
    date_from: new Date().toISOString().substr(0, 10),
    date_depotage: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    date_escale: new Date().toISOString().substr(0, 10),
    menu_from: false,
    menu_to: false,
    menu_escale: false,
    menu_depotage: false,
    navire: null,
    navireList: [],
    expanded: [],
    addNavireDialog: false,
    addPortDialog: false,
    addArmateurDialog: false,
    addConsigDialog: false,
    addConteneurDialog: false,
    drawerClass: '',
    row: 'import',
    dialog: false,
    
    businessCompanies: [
      {
        title: 'Import'
      },
      {
        title: 'Export'
      },
    ],
    armateur: '',
    portFrom: '',
    numDossier: '',
    numVoyage: '',
    numEscale: '',
    portTo: '',
    consig: '',
    portList: [],
    armateurList: [],
    consigList: [],
    folderTmp: {},
    dossiernum: '',
    aeroport_arrivee: '',
    aeroport_depart: '',
    num_lta: '',
    num_vol: '',
    compagnie_aerienne: '',
    type_conteneur: null,
    conteneur_num: '',
    num_escale_magasin: '',
    conteneurList:[]
  }),
  mounted () {
    this.axios
      .get('/dossier/listing')
      .then(response => { this.setDossierNumber(response.data)})
    this.reloadData()
    },
  methods: {
      openAddingTab(item){
        if(item === 'navire'){
          this.addNavireDialog = true
        }else if(item === 'armateur'){
          this.addArmateurDialog = true
        }else if(item === 'port'){
          this.addPortDialog = true
        }else if(item === 'conteneur'){
          this.addConteneurDialog = true
        }else if(item === 'consig'){
          this.addConsigDialog = true
        }
      },
      printValue() {
        console.log(this.selectedFilter);
      },
      reloadData(){
        this.axios
          .get('/navire/listing')
          .then(response => (this.navireList = response.data))
        this.axios
          .get('/conteneur/listing')
          .then(response => (this.conteneurList = response.data))

        this.axios
          .get('/armateur/listing')
          .then(response => (this.armateurList = response.data))

        this.axios
          .get('/port/listing')
          .then(response => (this.portList = response.data))

        this.axios
          .get('/consig/listing')
          .then(response => (this.consigList = response.data))
      },
      addFolder() {
        this.folderTmp.classe = this.classe
        this.folderTmp.date_depotage = this.date_depotage
        this.folderTmp.aeroport_depart = this.aeroport_depart
        this.folderTmp.aeroport_arrivee = this.aeroport_arrivee
        this.folderTmp.num_lta = this.num_lta
        this.folderTmp.num_vol = this.num_vol
        this.folderTmp.conteneur_num = this.conteneur_num
        this.folderTmp.conteneur_type_id = this.type_conteneur
        this.folderTmp.compagnie_aerienne = this.compagnie_aerienne
        this.folderTmp.num_escale_magasin = this.num_escale_magasin
        this.folderTmp.to_port_id = this.portTo
        this.folderTmp.from_port_id = this.portFrom
        this.folderTmp.num_dossier = this.dossiernum
        this.folderTmp.type = this.selectedFilter
        this.folderTmp.armateur_id = this.armateur
        this.folderTmp.consig_id = this.consig
        this.folderTmp.to_date = this.date_to
        this.folderTmp.from_date = this.date_from
        this.folderTmp.date_escale = this.date_escale
        this.folderTmp.num_voyage = this.numVoyage
        this.folderTmp.num_escale = this.numEscale
        this.folderTmp.navire_id = this.navire
        
        this.axios.post('/dossier/create', this.folderTmp, {
          }).then((res) => {
            if(res.data === 'error'){
              this.color = "error"
              this.snackbarText = "Essayez de remplir tous les champs obligatoires."
              this.snackbar = true
            }else{
              this.color = "success"
              this.snackbarText = "Le dossier a été ajouté avec succès."
              this.snackbar = true
              setTimeout( () => this.$router.push({ path: '/dashboard/dossier'}), 0);
            }
            
          }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
          })
      },
      setDossierNumber(dossier){
        if(dossier.length > 0){
          var nextCode = dossier.reduce((max, p) => p.numdossier > max ? p.numdossier : max, dossier[0].numdossier)
          if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
              nextCode = Number(nextCode)+1;
          }else{
              nextCode = new Date().getFullYear()+'0001'
          }
        }else{
          var nextCode = new Date().getFullYear()+'0001'
        }
        this.dossiernum = nextCode
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    text-align: left !important;
}
  .table-content {
    padding: 15px;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/dossier/new.vue